import { Component, type OnInit, type OnDestroy } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CDN_URL } from '@common/constant/cdn';
import { AuthSyncService } from './auth-sync.service';

@Component({
  template: `
    <div class="body-container">
      <div class="header">
        <a href="https://www.presence.com">
          <img
            [src]="cdnUrl + '/images/sirius/presence-logo.svg'"
            alt="Presence Logo"
          />
        </a>
      </div>

      <div class="main-container">
        <div class="content-container">
          <div class="title-container">
            <div class="title">You've been logged out</div>
          </div>

          <button type="button" (click)="login()" class="material-button">
            <span class="material-button-text">Return to login</span>
            <div class="material-button-ripple"></div>
          </button>

          <div class="content-footer">
            <div class="footer-text">
              <span>Having trouble signing in?</span>
              <span
                >Email
                <span class="email"
                  ><a href="mailto:asksupport@presence.com"
                    >asksupport&#64;presence.com</a
                  ></span
                >.</span
              >
            </div>
          </div>
        </div>

        <div
          class="image-container lockout-image"
          [style.background-image]="
            'url(' + cdnUrl + '/images/sirius/lockout-image.svg)'
          "
        ></div>
      </div>
    </div>
  `,
})
export class LoggedOutComponent implements OnInit, OnDestroy {
  cdnUrl = CDN_URL;

  private styleElement?: HTMLLinkElement;

  // Do NOT broadcast logout here - that should only happen from the tab
  // that initiates logout. Broadcasting on page load/refresh would log out
  // other tabs that have since logged in.

  // Do NOT auto-redirect or auto-authorize
  // The manual "Log in" button prevents race conditions where
  // tabs re-authenticate before the server-side logout completes

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private authSyncService: AuthSyncService
  ) {}

  ngOnInit() {
    // Load login.css only for this component
    this.styleElement = document.createElement('link');
    this.styleElement.rel = 'stylesheet';
    this.styleElement.href = `${CDN_URL}/css/sirius/login.css`;
    document.head.appendChild(this.styleElement);
  }

  ngOnDestroy() {
    // Clean up the stylesheet when component is destroyed
    if (this.styleElement && this.styleElement.parentNode) {
      this.styleElement.parentNode.removeChild(this.styleElement);
    }
  }

  login() {
    // CRITICAL: Clear the logout flag BEFORE authorizing
    // This allows the normal auth flow to proceed
    this.authSyncService.clearLogoutFlag();
    this.oidcSecurityService.authorize();
  }
}
